// ─── Constants ────────────────────────────────────────────────────────────────

export const DEFAULT_MAX_AGENT_ITERATIONS = 10

export const CONNECTOR_TYPE_DESCRIPTIONS: Record<number, string> = {
  1: 'Access SAP ERP data and transactions',
  2: 'Read and write Amazon S3 storage',
  3: 'Automate workflows with n8n',
  4: 'Connect to Priority ERP system',
  5: 'General HTTP/REST API connection',
  6: 'Access Microsoft 365 services',
  7: 'Query Microsoft SQL Server databases',
}

export const CONNECTOR_TYPE_COLORS: Record<number, string> = {
  1: '#0070f3',
  2: '#f59e0b',
  3: '#ef4444',
  4: '#8b5cf6',
  5: '#64748b',
  6: '#0078d4',
  7: '#cc2927',
}

export const KNOWN_TOOL_FIELDS = new Set([
  'name', 'title', 'description', 'httpMethod', 'path', 'bodyTemplate',
  'inputSchema', 'headerMap', 'queryMap', 'annotations', 'responseTemplate',
  'enabled', 'version', 'mainConnectionId', 'sampleResponse',
])

export const CREATE_SUGGESTIONS = [
  'Generate a GET tool to fetch a list of sales orders',
  'Create a POST tool to submit a new purchase order',
  'Build a tool to query inventory stock levels',
]

export const EDIT_SUGGESTIONS = [
  'Change the HTTP method to POST',
  'Update the path to include a dynamic ID parameter',
  'Add a Content-Type header',
]
